import React, { useEffect, useState } from 'react';
import { PanelType, useLeftSidePanelContext } from '../../context/LeftSidePanelContextProvider';
import { LazyFiltersPanel, LazyIncidentsFeedPanel, LazyMapViewPanel } from '../panels';

export const PanelResolver = () => {
  const { panel, closePanel } = useLeftSidePanelContext();
  const [loaded, setLoaded] = useState<Record<PanelType, boolean>>({
    [PanelType.Dashboard]: false,
    [PanelType.Filters]: false,
    [PanelType.IncidentsFeed]: false,
    [PanelType.MapView]: false,
  });

  useEffect(() => {
    if (panel) {
      setLoaded((state) => ({ ...state, [panel]: true }));
    }
  }, [panel]);

  if (!panel) {
    return null;
  }

  switch (panel) {
    case PanelType.Filters:
      return <LazyFiltersPanel closePanel={closePanel} animated={loaded[PanelType.Filters]} />;
    case PanelType.IncidentsFeed:
      return <LazyIncidentsFeedPanel closePanel={closePanel} animated={loaded[PanelType.IncidentsFeed]} />;
    case PanelType.MapView:
      return <LazyMapViewPanel closePanel={closePanel} animated={loaded[PanelType.MapView]} />;
    default:
      return null;
  }
};

export default PanelResolver;
